import { DocumentVersion } from "@models";
import NoPreview from "./NoPreview";
import { RenderImg } from "./RenderImg";
import { RenderPDF } from "./RenderPDF";

type FileData = NonNullable<DocumentVersion["file"]>;

interface FilePreviewProps {
  file: FileData;
  fileBlob: Blob;
  noPreviewMessage?: string;
}

export const FilePreview = ({
  file,
  fileBlob,
  noPreviewMessage,
}: FilePreviewProps) => {
  const previewMimeType = file.mimeType || fileBlob.type;

  if (previewMimeType?.includes("image")) {
    return <RenderImg file={file} fileBlob={fileBlob} />;
  }

  if (previewMimeType?.includes("pdf")) {
    return <RenderPDF fileBlob={fileBlob} />;
  }

  return <NoPreview file={file} message={noPreviewMessage} />;
};
